import React, { useMemo } from "react";
import KeyDetail from "../KeyDetail/KeyDetail";
import { UI_COLORS } from "../../config";
import { Card, Tag } from "antd";
import { useAppManager } from "../../hooks/useAppManager";
import { useTranslation } from "../../i18n";

export default function KeyDetailCard({ qrCodeUrl }) {
  const { t } = useTranslation();
  const {
    selectedKey,
    selectedValue,
    isLoadingValue,
    valueError,
    updateKeyValue,
    isUpdating,
    updateError,
    updateSuccess,
  } = useAppManager();
  

  const titleNode = useMemo(
    () => (
      <h3
        className="text-lg font-medium truncate"
        style={{
          color: UI_COLORS.primary,
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {t("keyDetail.title").toUpperCase()}
        {selectedKey && <Tag color={UI_COLORS.primary}>{selectedKey}</Tag>}
      </h3>
    ),
    [selectedKey, t]
  );


  return (
    <div className="w-full md:w-3/5 lg:w-2/3 h-1/2 md:h-full">
      <Card
        size="small"
        styles={{
          body: {
            height: "calc(100% - 50px)",
          },
          header: {
            height: 48.8,
          },
        }}
        className="h-full"
        title={titleNode}
      >
        <KeyDetail
          keyData={selectedKey}
          value={selectedValue}
          isLoading={isLoadingValue}
          error={valueError}
          qrCodeUrl={qrCodeUrl}
          onUpdateValue={updateKeyValue}
          isUpdating={isUpdating}
          updateError={updateError}
          updateSuccess={updateSuccess}
        />
      </Card>
    </div>
  );
}
export const MemoizedKeyDetailCard = React.memo(KeyDetailCard);
